// extracted by mini-css-extract-plugin
export default {"root":"ScrollBlock_root__2T52z"};